{
  "groups": {
    "boundariesSlots": "Limiti / Posizioni",
    "controls": "Controlli",
    "general": "Generale",
    "monitoring": "Monitoraggio",
    "speedFlow": "Velocità / Portata"
  },
  "linkedDevice": {
    "deviceAlias": "Alias del dispositivo"
  },
  "stopDetection": {
    "description": "Ti invia un SMS quando questo pivot viene rilevato mentre applica acqua senza muoversi, rimanendo entro il raggio della distanza minima per l'intera finestra di tempo.",
    "label": "Rilevamento arresto (GPS)",
    "minimumDistance": "Distanza minima",
    "timeWindow": "Finestra di tempo",
    "wheelDescription": "Ti invia un SMS quando il sensore della ruota del monitor collegato rileva che questo pivot ha smesso di muoversi.",
    "wheelLabel": "Rilevamento arresto (ruota)",
    "wheelUpdateFailed": "Impossibile aggiornare la notifica di arresto della ruota. Riprova."
  }
}
